import React, { type JSX } from 'react';
import { Paginator } from 'ui/common/paginator';
import { usePagination } from 'app/area/case-report/bowtie-listing/hooks';
import { BowtieTranslation } from '../../constants';
import { BowtieCase } from '../../types';
import { TooltipSectionElement } from './tooltip-parser';

import style from './tooltip-table-body.scss';

interface TooltipTableBodyProps {
  selectedConnections: BowtieCase[];
  selectedConnectionValue: number;
  templates: TooltipSectionElement[];
  renderField: (caseData: BowtieCase, fieldName: string) => JSX.Element;
  renderLabel: (caseData: BowtieCase, fieldName: string) => string;
  translation: BowtieTranslation;
}

const maxResultsPerPage = 5;

export const TooltipTableBody: React.FC<TooltipTableBodyProps> = ({
  selectedConnections, selectedConnectionValue, templates, renderField, renderLabel, translation
}) => {

  const sectionTemplate = templates.find(t => t.section === 'ConnectionType' + selectedConnectionValue) ||
    templates.find(t => t.section === 'ConnectionTypeDefault') ||
    templates[0];

  const template = sectionTemplate?.fields
    ?.filter(fieldName => typeof fieldName === 'string') as string[]
    || [];

  const paginatorProps = usePagination(selectedConnections.length, maxResultsPerPage, maxResultsPerPage);

  return <>
    <table>
      <thead>
        <tr>
          {template.map(fieldName => <th key={fieldName}>
            {renderLabel(selectedConnections[0], fieldName)}
          </th>)}
        </tr>
      </thead>
      <tbody>
        {selectedConnections
          .slice((paginatorProps.currentPage - 1) * maxResultsPerPage, paginatorProps.currentPage * maxResultsPerPage)
          .map((c, i) => <tr key={c.caseNumber || i}>
            {template.map(fieldName => <td key={`${c.caseNumber}_${fieldName}`}>
              <span className={style.tooltipTableField}>
                {renderField(c, fieldName)}
              </span>
            </td>)}
          </tr>)}
      </tbody>
    </table>
    {paginatorProps.shouldPaginate &&
      <div className={style.paginator}>
        <Paginator
          {...paginatorProps}
          textPageOf={translation.text_page_of} />
      </div>
    }
  </>;
};
